import { router, usePage } from '@inertiajs/react';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import BusinessRoundedIcon from '@mui/icons-material/BusinessRounded';
import DirectionsCarRoundedIcon from '@mui/icons-material/DirectionsCarRounded';
import HelpRoundedIcon from '@mui/icons-material/HelpRounded';
import HubRoundedIcon from '@mui/icons-material/HubRounded';
import InfoRoundedIcon from '@mui/icons-material/InfoRounded';
import MapRoundedIcon from '@mui/icons-material/MapRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Stack from '@mui/material/Stack';
import * as React from 'react';

const mainListItems = [
  { text: 'Analytics', icon: <AnalyticsRoundedIcon />, href: '/analytics' },
  { text: 'Torre de Controle', icon: <HubRoundedIcon />, href: '/towers' },
  { text: 'Mapa', icon: <MapRoundedIcon />, href: '/locations' },
  { text: 'Transportadoras', icon: <BusinessRoundedIcon />, href: '/carriers' },
  { text: 'Motoristas', icon: <DirectionsCarRoundedIcon />, href: '/drivers' },
  { text: 'Usuários', icon: <PersonRoundedIcon />, href: '/users' },
];

const secondaryListItems = [
  { text: 'Configurações', icon: <SettingsRoundedIcon /> },
  { text: 'Sobre', icon: <InfoRoundedIcon /> },
  { text: 'Feedback', icon: <HelpRoundedIcon /> },
];

export default function MenuContent() {
  const { props } = usePage();
  const userHasCarrier = props.current.user.carrier_id !== null && props.current.user.carrier_id !== undefined;

  const handleNavigation = (href) => {
    router.get(href);
  };

  // Filtrar itens do menu baseado no carrier_id do usuário
  // Usuários de transportadoras só podem ver Torre de Controle e Motoristas
  const filteredMainListItems = userHasCarrier
    ? mainListItems.filter(item =>
      item.text === 'Torre de Controle' || item.text === 'Motoristas'
    )
    : mainListItems;

  return (
    <Stack sx={{ flexGrow: 1, p: 1, justifyContent: 'space-between' }}>
      <List dense>
        {filteredMainListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton
              selected={window.location.pathname === item.href}
              sx={{ color: 'text.primary' }}
              onClick={() => handleNavigation(item.href)}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={index} disablePadding sx={{ display: 'block' }}>
            <ListItemButton>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
}
